<div class="content" [hidden]="isLoading">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

    <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="label" > Label
        </th>
        <td mat-cell *matCellDef="let element"> {{element.label}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="type" > Type
        </th>
        <td mat-cell *matCellDef="let element"> {{element.type}} </td>
    </ng-container>

    <ng-container matColumnDef="values">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="values">Valeurs</th>
        <td mat-cell *matCellDef="let element" class="cell_club">
          <span *ngIf="element.values === 'noValue'">Aucune valeur</span>
          <span *ngIf="element.values !== 'noValue'">{{getValues(element.type, element.values)}}</span>
         </td>
    </ng-container>

    <ng-container matColumnDef="isActive">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="isActive" > Activé
      </th>
      <td mat-cell *matCellDef="let element"> {{'boolean.' + element.isActive | translate}} </td>
  </ng-container>

    <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef class="cell_action"> Actions </th>
        <td mat-cell *matCellDef="let element" class="cell_action">
            <fa-icon [icon]="getFaIcon('faPen')" matTooltip="Editer ce paramètre"
                (click)="addOrEditParameter('edit',  element)" appChangeColorTheme attribute="color">
            </fa-icon>
            <fa-icon *ngIf="!element.isActive" [icon]="getFaIcon('faCheck')" matTooltip="Activer ce paramètre"
                (click)="activateDesactivate(element, true)" appChangeColorTheme attribute="color">
            </fa-icon>
            <fa-icon *ngIf="element.isActive" [icon]="getFaIcon('faBan')" matTooltip="Désactiver ce paramètre"
                (click)="activateDesactivate(element, false)" appChangeColorTheme attribute="color">
            </fa-icon>
        </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
</table>
<div class="no_resource" *ngIf="!dataSource?.filteredData.length">
    Aucun paramètre
</div>
<mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    (page)="pageEvent = $event" [color]="color">
</mat-paginator>
</div>
<mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>
